import React, { createContext, useContext } from 'react';
// import { useNavigate } from 'react-router';
import { useAtom } from 'jotai';
import { Snackbar, Alert, AlertTitle, Typography, Link } from '@mui/material';
import { messageNotificationAtom } from '../../state/atoms';
// import { PATH_DASHBOARD } from '../../routes/paths';

const NotificationContext = createContext();
export const useNotifications = () => useContext(NotificationContext);

const NotificationSnackBar = ({ notification, setNotification }) => {
//   const navigate = useNavigate();

//   const TO_CONVO = `${PATH_DASHBOARD.messages}${PATH_DASHBOARD.conversation}`;

//   const handleNavigate = () => {
//     if (notification?.data?.id) {
//       navigate(`${TO_CONVO}/${notification?.data?.id}`);
//     }
//     setNotification({ title: null, options: null, data: null });
//   };

  const handleClose = () => {
    setNotification({ title: null, options: null, data: null });
  };
  return (
    <Snackbar
      open={!!notification.title}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      //   onClick={handleNavigate}
    >
      <Alert
        variant="outlined"
        severity="warning"
        icon={<img src={notification?.options?.icon} style={{ width: '40px', height: '40px' }} alt="Icon" />}
        onClose={handleClose}
        sx={{ bgcolor: 'background.paper', width: '100%', display: 'flex', alignItems: 'center' }}
      >
        <AlertTitle>
          New message received:{' '}
          <Typography variant="body1" fontWeight={700}>
            {notification.title}
          </Typography>
        </AlertTitle>
        <Typography variant="body2">{notification?.options?.body || ''}</Typography>
      </Alert>
    </Snackbar>
  );
};
export const MessageNotificationsProvider = ({ children }) => {
  const [notification, setNotification] = useAtom(messageNotificationAtom);

  const showNotification = (title, options, data) => {
    setNotification({ title, options, data });
  };

  return (
    <NotificationContext.Provider value={showNotification}>
      {children}
      <NotificationSnackBar notification={notification} setNotification={setNotification} />
    </NotificationContext.Provider>
  );
};
